var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLineUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-line-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.41699 19.4582C2.07191 19.4582 1.79199 19.1783 1.79199 18.8332C1.79199 18.4881 2.07191 18.2082 2.41699 18.2082H19.0837C19.4287 18.2082 19.7087 18.4881 19.7087 18.8332C19.7087 19.1783 19.4287 19.4582 19.0837 19.4582H2.41699ZM10.7503 14.4582C11.0954 14.4582 11.3753 14.1783 11.3753 13.8332V3.6753L14.4751 6.77505C14.5972 6.89713 14.7571 6.95813 14.917 6.95813C15.0769 6.95813 15.2368 6.89713 15.3589 6.77505C15.6031 6.53088 15.6031 6.13538 15.3589 5.8913L11.1922 1.72463C10.9481 1.48046 10.5526 1.48046 10.3085 1.72463L6.14174 5.8913C5.89758 6.13546 5.89758 6.53096 6.14174 6.77505C6.38591 7.01913 6.78141 7.01921 7.02549 6.77505L10.1252 3.6753V13.8332C10.1252 14.1783 10.4052 14.4582 10.7503 14.4582Z",
    fill: "#213A51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineUp);
export default __webpack_public_path__ + "static/media/arrow-line-up.e6391433310d92fb8059b3468be271c3.svg";
export { ForwardRef as ReactComponent };